import axios from '@/utils/axios.js'
import { getFingerprint } from '@/utils/fingerprint.js'

/**
 * 上传文件
 * @param {*} url 请求地址
 * @param {*} param el-upload 组件参数
 * @returns 文件信息
 */
export async function upload(url, param) {
  const formData = new FormData()
  formData.append('file', param.file)
  const { data } = await axios({
    method: 'post',
    url: url,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    onUploadProgress(progressEvent) {
      const percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
      param.onProgress({ percent: percent })
    },
  })
  return data
}

export async function uploadManga(url, param) {
  const formData = new FormData()
  formData.append('file', param.file)

  const { data } = await axios({
    method: 'post',
    url: url,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    onUploadProgress(progressEvent) {
      const percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
      param.onProgress({ percent: percent })
    },
  })
  return data
}

export async function uploadMultipleManga(url, files, onProgress) {
  const maxFiles = 20

  if (files.length > maxFiles) {
    throw new Error(`最多只能上传${maxFiles}张图片`)
  }

  // 创建单个FormData，包含所有文件
  const formData = new FormData()

  // 将所有文件添加到FormData中，参数名为'files'
  files.forEach((file, index) => {
    // 支持两种格式：包含raw属性的对象或直接是文件对象
    const actualFile = file.raw || file
    formData.append('files', actualFile)
  })

  // 添加额外的参数（如果需要）
  formData.append('total', files.length.toString())

  // 添加浏览器指纹用于防刷
  const fingerprint = await getFingerprint()
  formData.append('fingerprint', fingerprint)

  try {
    if (onProgress) {
      onProgress({
        current: 1,
        total: 1,
        fileName: `批量上传 ${files.length} 张图片`
      })
    }

    const { data } = await axios({
      method: 'post',
      url: url,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    })

    // 直接返回完整的响应数据，让调用方处理结构
    return data
  } catch (error) {
    console.error('批量上传失败:', error)
    throw error
  }
}

export async function uploadBayKey(url, param, key, val) {
  const formData = new FormData()
  formData.append('file', param.file)
  formData.append(key, val)
  const { data } = await axios({
    method: 'post',
    url: url,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    onUploadProgress(progressEvent) {
      const percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
      param.onProgress({ percent: percent })
    },
  })
  return data
}

export const downloadManga = (id, code) => {
  const params = { id }
  if (code) params.code = code
  return axios({
    url: '/manga/user/download', // 后端下载接口地址
    method: 'GET',
    params, // 传递图片ID参数
    responseType: 'blob', // 关键：指定响应类型为二进制流
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  })
}

export const batchDownloadManga = (ids, code, onProgress) => {
  const data = { ids }
  if (code) data.code = code
  return axios({
    url: '/manga/user/batchDownload', // 后端批量下载接口地址
    method: 'POST',
    data, // 传递图片ID数组
    responseType: 'blob', // 关键：指定响应类型为二进制流（ZIP文件）
    headers: {
      'Content-Type': 'application/json'
    },
    onDownloadProgress: onProgress ? (e) => {
      if (e.total) {
        onProgress(Math.round((e.loaded / e.total) * 100))
      }
    } : undefined
  })
}